import { render } from "./ProgramInvitaionLists.vue?vue&type=template&id=672290cc&scoped=true"
import script from "./ProgramInvitaionLists.vue?vue&type=script&lang=js"
export * from "./ProgramInvitaionLists.vue?vue&type=script&lang=js"

import "./ProgramInvitaionLists.vue?vue&type=style&index=0&id=672290cc&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672290cc"]])

export default __exports__